import { createClient } from "@supabase/supabase-js"

// Create a single supabase client for interacting with your database
const supabase = createClient(
  "https://lybsdrweluwmzcfrlhsi.supabase.co",
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imx5YnNkcndlbHV3bXpjZnJsaHNpIiwicm9sZSI6ImFub24iLCJpYXQiOjE2OTQ1MzQ3NzgsImV4cCI6MjAxMDExMDc3OH0.r7ehcCgDHzGJHlkBsgY59KRIsmItJj3KiUNzgrd79k0"
)

export default supabase
